var takeover = {
	$this: $( '.js-take-over' ),
};

const $btnMenu = $( '.js-menu-btn' ),
	$btnSearch = $( '.js-search-btn' ),
	$btnSubmitSearch = $( '.submit .search-ex' ),
	$closeBtn = $( '.js-close-btn' ),
	$scroller = $( '.js-take-over .scroller' ),
	$innerScroller = $( '.js-take-over .scroller .inner-scroller' ),
	$container = $( '.js-container' ),
	bgTakeover = ( $( '.bg-mask-takeover-outer' ).length > 0 ) ? true : false;

let setScrollTop = 0,
	bgTimeout = ( bgTakeover ) ? 500 : 0;

function open() {
	$innerScroller.removeAttr( 'style' );
	$( 'body' ).icons.init( '.svg-icon' );
	setScrollTop = $( window ).scrollTop();

	if ( bgTakeover ) {
		$( '.bg-mask-takeover-outer' ).addClass( 'show' );
	}
	setTimeout( function() {
		takeover.$this.css( 'visibility', 'visible' );
		setTimeout( function() {
			takeover.$this.addClass( 'show' );
		}, 10 );
		$closeBtn.addClass( 'show' );
		$( 'body' ).addClass( 'fixed' );
		$container.addClass( 'fixed' ).css( { 'margin-top': -Math.abs( setScrollTop ) } );
	}, bgTimeout );
}

function close() {
	$closeBtn.removeClass( 'show' );
	takeover.$this.removeClass( 'show' );
	setTimeout( function() {
		takeover.$this.removeAttr( 'style' );
	}, 300 );
	$( 'body' ).removeClass( 'fixed' );
	$container.removeClass( 'fixed' ).removeAttr( 'style' );
	$( window ).scrollTop( setScrollTop );
	if ( bgTakeover ) {
		setTimeout( function() {
			$( '.bg-mask-takeover-outer' ).removeClass( 'show' );
		}, bgTimeout );
	}
}

function checkLength( e, submit ) {
	var val = $('.js-search input[type="text"]').val();
	$( '.js-search .length_test').html(val);
	var width = $('.js-search .length_test').outerWidth( true );
	$('.js-search .stroke .inner').css({'width' : width});
}

function stickyFooter() {
	if ( Modernizr.mq( '(min-width: 1024px)' ) ) { // desktop

		var headerHeight = $( '.takeover-header' ).outerHeight(true),
			footerHeight = $( '.takeover-footer' ).outerHeight(true),
			contentHeight = $( '.takeover-content' ).outerHeight(true),
			contentNewHeight = $(window).height() - headerHeight - footerHeight;

		setTimeout( function() {
			if ( contentHeight < contentNewHeight ) {
				$( '.takeover-content' ).css( 'min-height', contentNewHeight );
			}
		}, 100 );
	}
}

function searchResults() {

	var $searchDiv = $('.js-take-over.search-take-over'),
		$search = $searchDiv.find('form.the_form'),
		$searchResults = $searchDiv.find('.search-results');


	$search.submit( function(e) {


		e.preventDefault();

		var val = $search.find('.search-ex input' ).val();

		var data = $(this).serialize();


		if ( val.length > 2 ) {

			$.ajax({
				url: customData.ajaxURL,
				// asynch: false,
				data: data,
				dataType: 'json',
				method: 'POST',
			})
			.done(function (thisdata, textStatus, jqCHR) {
				if ( thisdata != '' && thisdata != '""' ) {
					// data = $.parseJSON( thisdata );
					data = thisdata;

					//window.history.replaceState( {} , document.title,  '?s=' + data.s );

					// if ($searchResults.hasClass('shown')) {
					// 	// refresh content
					// } else {
					// 	$search.addClass('results-shown');
					// 	$searchResults.addClass('shown');
					// }

					if ( data.results != false ) {

						$searchResults.html( '' );
						$searchResults.html( data.result_count + data.results);

					} else {

						$searchResults.html( '<h4 class="small">' + data.message + '</h4>' );
					}
				}
			});
		}
	});
}

takeover.init = function() {
	$btnMenu.on( 'click', function( e ) {
		e.preventDefault();
		takeover.$this = $( '.js-take-over.menu-take-over' );
		stickyFooter();
		open();
	} );

	$btnSearch.on( 'click', function( e ) {
		e.preventDefault();
		takeover.$this = $( '.js-take-over.search-take-over' );
		open();
		searchResults();
	} );

	$closeBtn.on( 'click', function( e ) {
		e.preventDefault();
		close();
	} );

	$( '.js-search .input input[type="text"]' ).keypress(function( e ) {
		checkLength( e, false );
	});

	$( '.js-search .input input[type="text"]' ).keyup(function( e ) {
		checkLength( e, true );
	});

	//$btn.click();

}

export { takeover };
